/**
 * Opens the Didomi preferences manager (required footer access for CA/US privacy laws).
 */
export function openDidomiPreferences() {
  if (typeof window === 'undefined') {
    return false;
  }

  const { Didomi } = window;
  if (Didomi && Didomi.preferences && typeof Didomi.preferences.show === 'function') {
    Didomi.preferences.show();
    return true;
  }

  return false;
}
